import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  findByList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/campusIntroduction/findByList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/campusIntroduction/findById`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  save({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/campusIntroduction/save`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },


  upload({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/file/upload`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },


}









